<template>
  <div class="resetPassword">
    <el-main>
      <el-row class="nofull">
        <el-main>
          <el-row style="width: 360px; margin: 30px auto">
            <img class="logo" src="../assets/logo_new.png" />
            <div class="site_name">{{ siteName }}</div>
          </el-row>
          <el-row style="width: 360px; margin: 0 auto">
            <p style="margin-bottom: 20px">设置新密码</p>
            <el-form :model="setNewPWForm" :rules="rules" ref="setNewPWForm">
              <el-form-item class="setNewPWFormItem" prop="newPwd">
                <el-input
                  placeholder="输入新密码"
                  v-model="setNewPWForm.newPwd"
                  type="password"
                >
                  <template slot="prepend"
                    >新<span style="margin-left: 0.5em" />密<span
                      style="margin-left: 0.5em" />码<i class="el-icon-lock"
                  /></template>
                </el-input>
              </el-form-item>
              <el-form-item
                class="setNewPWFormItem"
                prop="rePwd"
                style="margin-bottom: 20px"
              >
                <el-input
                  placeholder="确认新密码"
                  v-model="setNewPWForm.rePwd"
                  type="password"
                >
                  <template slot="prepend"
                    >确认密码<i class="el-icon-lock"
                  /></template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-alert
              :style="{ display: serNewPWMessageVisible }"
              :title="serNewPWMessage"
              type="error"
              @close="serNewPWMessageClose"
            >
            </el-alert>
            <el-button
              :loading="loading"
              type="primary"
              style="width: 100%"
              @click="handleSetNewPassword"
              >{{ loading ? '正在设置新密码 ...' : '确 定' }}</el-button
            >
          </el-row>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import { postSetNewPassword } from '@/apis/setNewPassword.js';
export default {
  name: 'ResetPassword',
  mounted() {
    this.$emit('activeIndex', '');
    this.$emit('pageClass', 'userCenter');
  },
  props: {
    siteName: String,
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.setNewPWForm.newPwd !== '') {
          this.$refs.setNewPWForm.validateField('rePwd');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.setNewPWForm.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        newPwd: [
          {
            validator: validatePass,
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          { min: 6, message: '密码至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '密码最多 20 个字符', trigger: 'blur' },
        ],
        rePwd: [{ validator: validatePass2, trigger: 'blur' }],
      },
      serNewPWMessageVisible: 'none',
      serNewPWMessage: '',
      user_name: '',
      loading: false,
      setNewPWForm: {
        newPwd: '',
        rePwd: '',
      },
    };
  },
  methods: {
    handleSetNewPassword() {
      postSetNewPassword({
        new_login_password: this.newPwd,
        confirm_login_password: this.rePwd,
      })
        .then((res) => {
          this.loading = true;
          console.log(res.data);
          this.timer = setTimeout(() => {
            // 动画关闭需要一定的时间
            if (res.status === 200) {
              setTimeout(() => {
                this.loading = false;
                if (res.data.data.message === 1) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: '成功',
                  });
                } else if (res.data.data.message === 2) {
                  this.$message({
                    showClose: true,
                    type: 'warning',
                    message: '错误',
                  });
                }
              }, 800);
            } else {
              this.$message.error('未请求成功');
              this.loading = false;
              console.log('请求错误');
            }
            this.$router.replace('/rePWDSuccess');
          }, 2000);
        })
        .catch(() => {
          this.$message.error('未请求成功');
        });
    },
    serNewPWMessageClose() {
      this.serNewPWMessageVisible = 'none';
    },
  },
};
</script>

<style scoped></style>
